<button *ngIf="wyborFirmyMenu?.length > 0" nbButton outline class="przycisk-kontakt" size="small" title="{{ 'akcja.zmien-firme' | translate }}" [nbContextMenu]="wyborFirmyMenu" [nbContextMenuTag]="wyborFirmyMenuTag">
  {{ 'akcja.zmien-firme' | translate }}
</button>